export const trading = {
    kpsj: "Waktu Pembukaan",
    jlks: "Mulai Dalam",
    t: "Hari",
    s: "Jam",
    f: "Menit",
    m: "Detik",

    zgj: "Harga Tertinggi:",
    zdj: "Harga Terendah:",
    gflj: "Tautan Resmi",
    gw: "Situs Web",
    qkllq: "Penjelajah Blokchain",
    scfxsj: "Waktu Rilis Pertama",
    fxzl: "Total Suplai",
    ltzl: "Total Sirkulasi",
    jy: "Trading",
    sj: "Market",
    tbxx: "Informasi Grafik",
    bzgk: "Ikhtisar Mata Uang",
    jcb: "Versi Dasar",
    ddb: "Tabel Order",
    zxcj: "Eksekusi Terbaru",

    reload: "Muat Ulang",
    socketError: "Kesalahan Jaringan, Silakan",
    noData: "Belum Ada Data",
    entrustorder: "Buku Order",
    prices: "Harga",
    quantity: "Jumlah",
    grandtotal: "Akumulasi",
    transamount: "Volume Trading",
    time: "Waktu",
    available: "Tersedia",
    limitorder: "Limit",
    plancommission: "Order Rencana",
    currentcommission: "Order Berjalan",
    historycommission: "Riwayat Order",
    completecommission: "Order Terekseskusi",
    funds: "Dana",
    hidetrading: "Sembunyikan Pair Lain",
    morecurrentcommission: "Lebih Banyak Order Berjalan",
    morehistorycommission: "Lebih Banyak Riwayat Order",
    moredocommission: "Lebih Banyak Order Terekseskusi",
    realtimetrans: "Eksekusi Real-time",
    myassets: "Aset Saya",
    detail: "Detail",
    buyin: "Beli",
    sellout: "Jual",
    login: "Login",
    transfer: "Transfer",
    recharge: "Setor",
    withdrawal: "Beli Koin",
    quickpurchase: "Beli Koin Cepat dengan Fiat",
    default: "Default",
    ordertime: "Waktu Order",
    tradingpair: "Pair Trading",
    direction: "Arah",
    types: "Tipe",
    commissionprice: "Harga Order",
    commissionnumber: "Jumlah Order",
    dealprice: "Harga Rata-rata Eksekusi",
    dealnumber: "Jumlah Terekseskusi",
    triggerprice: "Harga Trigger",
    cancelall: "Batalkan Semua Order",
    averageprice: "Harga Rata-rata",
    totalsum: "Total",
    fixedprice: "Limit",
    marketprice: "Market",
    codeExpired: "Kode QR Kadaluarsa",
    clickRefresh: "Klik untuk Segarkan",
    QRsuccessfully: "Pemindaian Berhasil",
    loginInApp: "Harap konfirmasi login di dalam APP",
    backtoQR: "Kembali ke Login Kode QR",
    loginSuccess: "Anda telah berhasil login, selamat datang di biking!",
    loadingText: "Memuat...",
    searchPlaceholder: "Cari",
    all: "Semua",
    currency: "Mata Uang",
    price: "Harga Terkini",
    market: "Peringkat Perubahan",
    increase: "Perubahan",
    highestPrice: "Tertinggi",
    minimumPrice: "Terendah",
    turnover: "Volume",
    jydlb: "Daftar Pair Trading",
    bzjs: "Pengenalan Mata Uang",
    currencyTransaction: "Trading Spot",
    leveragedTransaction: "Trading Leverage",
    warning:
        "Peringatan Risiko: Fork Bitcoin Cash memiliki ketidakpastian yang sangat besar, trading atau berinvestasi dalam token futures fork memiliki risiko yang sangat besar. Jika suatu rantai kekurangan dukungan penambang, kemungkinan besar tidak dapat bertahan, dan token terkait yang dipegang berisiko menjadi nol. BiKing tidak membuat janji apa pun mengenai nilai token futures fork mana pun!",
    zb: "Indikator",
    date: "Waktu",
    UpAnddown: "Naik/Turun",
    amplitude: "Amplitudo",
    0: "Garis Waktu",
    1: "1 Menit",
    5: "5 Menit",
    15: "15 Menit",
    30: "30 Menit",
    60: "1 Jam",
    240: "4 Jam",
    3600: "1 Hari",
    10800: "1 Minggu",
    dates: "Periode:",
    password: "Kata Sandi Trading",
    errorPassword: "Silakan masukkan kata sandi trading yang benar",
    worningPassword: "Silakan masukkan kata sandi trading",
    cancel: "Batal",
    sure: "Konfirmasi",
    canBuy: "Dapat Dibeli",
    canCell: "Dapat Dijual",
    withdraw: "Tarik Koin",
    otc: "OTC, Masuk/Cair Cepat dengan Fiat",
    enterPrice: "Silakan masukkan harga",
    sellingPrice: "Harga Jual",
    purchasePrice: "Harga Beli",
    salesVolume: "Volume Jual",
    buyingVolume: "Volume Beli",
    volume: "Volume Trading",
    serviceCharge: "Biaya",
    vip: "Upgrade VIP, Nikmati Diskon Biaya Sekarang",
    or: "atau",
    register: "Daftar",
    totalPrice: "Volume trading tidak boleh lebih besar dari",
    amountTip: "Silakan masukkan jumlah yang benar",
    amountTipError: "Jumlah tidak boleh lebih besar dari",
    limitTrading: "Trading Limit",
    priceReminder: "Pengingat Harga",
    SMSReminder: "Pengingat SMS",
    loginAccount: "Login Akun",
    phone: "Telepon",
    phoneNum: "Silakan masukkan nomor telepon",
    phoneTips: "Silakan masukkan nomor telepon yang benar",
    email: "Email",
    emailNum: "Silakan masukkan email",
    emailTips: "Silakan masukkan email yang benar",
    aears: "Silakan pilih kode area",
    passwordError: "Silakan masukkan kata sandi yang benar",
    passwordTips: "Silakan masukkan kata sandi",
    forgetPassword: "Lupa Kata Sandi",
    noAccount: "Tidak punya akun",
    goRegister: "Daftar Sekarang",
    appsys: "Pindai Kode QR APP untuk Login Aman",
    xzapp: "Unduh APP Terbaru",
    mmdl: "Login dengan Kata Sandi",
    smdl: "Login dengan Kode QR",
    google: "Google Authenticator",
    nybd: "Anda telah mengikat",
    zqyzm: "Silakan masukkan kode verifikasi yang benar",
    fsyzm: "Kirim Kode Verifikasi",
    flv: "Tingkat Biaya",
    jz: "Nilai Bersih (NAV)",
    jzdesc1:
        "NAV Long = NAV pada titik penyesuaian sebelumnya * [1+3*(Harga eksekusi spot terbaru - Harga spot pada titik penyesuaian sebelumnya)/Harga spot pada titik penyesuaian sebelumnya*100%];",
    jzdesc2:
        "NAV Short = NAV pada titik penyesuaian sebelumnya * [1-3*(Harga eksekusi spot terbaru - Harga spot pada titik penyesuaian sebelumnya)/Harga spot pada titik penyesuaian sebelumnya*100%];",
    sbd: "3x Long",
    sbs: "3x Short",
    flvjs:
        'Tingkat pendanaan ETF adalah biaya manajemen yang dikenakan platform setiap hari terhadap leverage dengan proporsi yang sesuai, untuk membayar tingkat pendanaan yang dihasilkan oleh kombinasi dana. Biaya manajemen akan tercermin dalam perubahan nilai bersih, yaitu dengan cara "mengurangi nilai ETF leverage yang sesuai", dan hanya akan dikenakan pada pukul 0:00 waktu Singapura. Jika Anda tidak memegang produk pada waktu tersebut, tidak akan ada biaya yang dikenakan.',
    mzsm: "Pernyataan Penolakan",
    ido: "Saya telah membaca dan menyetujui",
    exemption1: "Pelanggan yang terhormat, halo!",
    exemption2:
        "Terima kasih telah login dan menggunakan produk ETF leverage dan layanan terkait (selanjutnya disebut \"Produk ETF\") yang disediakan oleh platform BiKing (BiKing.ai). Harap baca dengan cermat penjelasan produk ETF dan peringatan risiko berikut ini. Setelah membaca dan terus menggunakan Produk ETF, Anda dianggap telah sepenuhnya memahami dan mengerti risiko Produk ETF, mampu menanggung kerugian yang mungkin timbul dari penggunaan Produk ETF, dan dianggap menyetujui semua isi pernyataan penolakan ini. Silakan klik untuk membaca penjelasan produk ETF:",
    exemption3: "《FAQ Produk ETF Leverage》",
    exemption4: "Peringatan Risiko:",
    exemption5:
        "1. Harga beli/jual Anda tidak boleh menyimpang terlalu jauh dari nilai bersih per unit, jika tidak Anda akan menderita kerugian yang sesuai.",
    exemption6: "2. Jika arah prediksi salah, dalam kondisi pasar yang ekstrem terdapat risiko harga mendekati nol.",
    exemption7:
        "Platform BiKing dengan ini dengan sungguh-sungguh mengingatkan Anda bahwa kerugian atau tanggung jawab yang timbul dari risiko di atas akan ditanggung sendiri oleh Anda, dan platform BiKing tidak bertanggung jawab atas hal ini. Pernyataan penolakan ini, bersama dengan perjanjian, pernyataan, aturan, dll. lainnya di dalam platform BiKing, membentuk seluruh kesepakatan antara platform BiKing dan Anda mengenai layanan dan produk platform BiKing.",
    bzjs1: "1、“3L” menunjukkan jika harga pair trading acuan naik 1%, nilai bersih produk ini naik 3%",
    bzjs2: "2、“3S” menunjukkan jika harga pair trading acuan turun 1%, nilai bersih produk ini naik 3%",
    bzjs3: "3、Nilai bersih biasanya disesuaikan setiap hari pada pukul 0:00, kondisi pasar ekstrem akan disesuaikan selama sesi trading",
    bzjs4: "4、Setiap kali leverage akan dikenakan biaya manajemen harian yang sesuai",
    bzjs5:
        "5、Sebelum trading, harap perhatikan nilai bersih. Produk ini dalam kondisi pasar ekstrem berisiko harga mendekati nol dan harga menyimpang jauh dari nilai bersih, harap investor memperhatikan kontrol risiko",
    gdjk: "Untuk detail lebih lanjut, silakan lihat pengumuman",
    firstTrading: "Sebelum trading pertama, harap atur kata sandi trading terlebih dahulu",
    status: "Status",
    status1: "Menunggu Pencocokan",
    status2: "Belum Terekseskusi",
    status3: "Dibatalkan Pengguna",
    status4: "Terekseskusi Sebagian",
    status5: "Terekseskusi Penuh",
    status6: "Tidak Valid",
    allCancel: "Batalkan Semua Order Secara Massal",
    canceld: "Batalkan Order",
    cancelsuccess: "Semua Order Berhasil Dibatalkan, [*] Order Telah Dibatalkan",
    VIP1: "Level Anda VIP",
    VIP2: "Biaya trading yang lebih rendah, pengalaman trading yang lebih baik",
    VIP3: "Taker (Ambil Order):",
    VIP4: "Maker (Buat Order):",
    buyAmount: "Jumlah beli tidak boleh lebih tinggi dari",
    sellAmount: "Jumlah jual tidak boleh lebih tinggi dari",
    buyAmountMin: "Saldo yang dapat dibeli tidak cukup",
    sellAmountMin: "Saldo yang dapat dijual tidak cukup",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/ba.js